import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  TextField,
  Typography,
  Alert,
} from '@mui/material'
import { useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { apiRoot } from '../config'

function ForgotPasswordPage() {
  const { t } = useTranslation()
  const { register, handleSubmit, formState: { errors } } = useForm<{ email: string }>()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState<{ success?: boolean; message?: string } | null>(null)

  const handleForgotPassword = async (data: { email: string }) => {
    setIsSubmitting(true)
    setSubmitStatus(null)

    try {
      await axios.post(apiRoot + '/auth/password/reset/', {
        email: data.email,
      })
      setSubmitStatus({
        success: true,
        message: t('resetPasswordSuccess'),
      })
    } catch (error) {
      setSubmitStatus({
        success: false,
        message: t('resetPasswordError'),
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Container maxWidth="xs">
      <Box
        component="form"
        sx={{
          mt: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit(handleForgotPassword)}
      >
        <Typography component="h1" variant="h5">
          {t('resetPasswordTitle')}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: 3, textAlign: 'center' }}>
          {t('resetPasswordInstruction')}
        </Typography>

        {submitStatus && (
          <Alert severity={submitStatus.success ? 'success' : 'error'} sx={{ width: '100%', mb: 2 }}>
            {submitStatus.message}
          </Alert>
        )}

        <TextField
          {...register('email', {
            required: t('emailRequired'),
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: t('invalidEmail'),
            },
          })}
          margin="normal"
          required
          fullWidth
          id="email"
          label={t('emailLabel')}
          autoComplete="email"
          error={!!errors.email}
          helperText={errors.email ? String(errors.email.message) : ''}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <CircularProgress size={24} />
          ) : (
            t('sendResetLinkBtn')
          )}
        </Button>

        <Grid container justifyContent="center">
          <Grid item>
            <Link to="/login" style={{ textDecoration: 'none' }}>
              <Typography color="primary" variant="body2">
                {t('rememberPasswordLink')}
              </Typography>
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Container>
  )
}

export default ForgotPasswordPage
